import type { Breakpoints } from '../breakpoints';

import { useTheme } from './useTheme';

export function useBreakpoints(): Breakpoints {
	return useTheme().breakpoints;
}
